module.exports = __webpack_public_path__ + "static/12 - LU-83f1975c92f88d7fd59115a8e7c29c25.jpg";